export default "__VITE_ASSET__DnXoRq_X__"